import * as Redux from "redux";

import * as Messages from "./messages"
import * as Shell from "./shell"
import * as Login from "./login"
import * as PwdRecovery from "./pwd.recovery"
import * as PwdExpired from "./pwd.expired"
import * as PwdValidate from "./pwd.validate"
import * as PwdSecurity from "./pwd.security"

export interface ReducerState {
    shell: Shell.ReducerState
    messages: Messages.ReducerState
    login: Login.ReducerState
    pwdRecovery: PwdRecovery.ReducerState,
    pwdExpired: PwdExpired.ReducerState,
    pwdValidate: PwdValidate.ReduserState,
    pwdSecurity: PwdSecurity.ReducerState
}

export const reducers = Redux.combineReducers<ReducerState>({
    messages: Messages.reducer,
    shell: Shell.reducer,
    login: Login.reducer,
    pwdRecovery: PwdRecovery.reducer,
    pwdExpired: PwdExpired.reducer,
    pwdValidate: PwdValidate.reducer,
    pwdSecurity: PwdSecurity.reducer
});